import ButtonBase from "@mui/material/ButtonBase";
import {
  B2C_PRIMARY_COLOR,
  BORDER_BOTTOM,
  ICON_DARK,
  WHITE,
} from "ds_legacy/materials/colors";
import {
  border,
  dp,
  margin,
  padding,
  responsiveCSS,
  sizing,
} from "ds_legacy/materials/metrics";
import { SHADOW_DP1 } from "ds_legacy/materials/shadows";
import { Body, FONT_SIZE_16 } from "ds_legacy/materials/typography";
import React from "react";
import styled, { css } from "styled-components";

const DefaultTile = styled(ButtonBase)`
  border: ${border({ color: BORDER_BOTTOM, important: true })};
  box-shadow: ${SHADOW_DP1}!important;
  background-color: ${WHITE}!important;
  width: ${dp(163)}!important;
  height: ${sizing(7)}!important;
  margin: ${margin(1)}!important;
  padding: ${padding(0, 1)}!important;
`;

export const TILE_WIDTH = dp(240);
const B2CTile = styled(ButtonBase)<{ $hasIcon?: boolean }>`
  background-color: ${B2C_PRIMARY_COLOR}!important;
  box-shadow: none;
  border: ${border({ color: B2C_PRIMARY_COLOR, important: true, width: 2 })};
  margin: ${margin(1, 1)}!important;
  padding: ${padding(2, 2)}!important;
  width: ${TILE_WIDTH}!important;
  height: ${sizing(7)};
  ${({ $hasIcon }) =>
    !$hasIcon &&
    css`
      justify-content: center !important;
    `}
  span {
    font-size: ${sizing(2)} !important;
  }
  span,
  svg {
    color: ${WHITE}!important;
  }
  @media (hover: hover) and (pointer: fine) {
    &:hover {
      background-color: ${WHITE}!important;
      span,
      svg {
        color: ${B2C_PRIMARY_COLOR}!important;
      }
    }
  }
  transition: all 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  ${responsiveCSS({
    desktop: [`align-self: flex-start`],
    mobile: [
      `align-self: center`,
      `width: calc(100% - ${sizing(2)})!important`,
    ],
    tablet: [`align-self: center`],
  })};
`;

export const TILETYPE = {
  B2C: "B2C",
  DEFAULT: "DEFAULT",
} as const;
const TILES = {
  B2C: B2CTile,
  DEFAULT: DefaultTile,
} as const;

export default function Tile({
  Icon,
  label,
  onClick,
  tileType = TILETYPE.DEFAULT,
}: {
  Icon?: React.ComponentType<any>;
  label: string;
  onClick: () => void;
  tileType?: keyof typeof TILES;
}) {
  const TileWrapper = TILES[tileType];
  return (
    <TileWrapper
      $hasIcon={!!Icon}
      style={{
        alignItems: "center",
        boxSizing: "border-box",
        display: "flex",
        justifyContent: "flex-start",
      }}
      onClick={onClick}
    >
      {Icon && (
        <Icon
          size={FONT_SIZE_16}
          style={{
            color: ICON_DARK,
            height: sizing(2),
            width: sizing(2),
          }}
        />
      )}
      <Body margin={margin(0, 1)}>{label}</Body>
    </TileWrapper>
  );
}
